module.exports = __webpack_public_path__ + "static/tcs-7cdde419c670942077ad5b60154768b4.png";